export default "__VITE_ASSET__NsQTZ8cC__"